export default {"src":"/_next/static/media/sponser3.da247125.svg","height":46,"width":118,"blurWidth":0,"blurHeight":0};